/**
 * Financial Page Accordions
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';
import { SingleAccordion } from '../reusable/accordions/SingleAccordion.js';

/**
 * Initialize the accordions on the financial templates.
 *
 * Most sections in the template are collapsible so that mobile users are not faced
 * with an extremely long scrolling page.
 *
 * @return {void}
 */
export function init() {
    const accordions = $$('.market-movers__listing, .articles-listing, .financial-table-section').map((el) => [
        el.querySelector('header'),
        el.querySelector('main'),
    ]);

    accordions.push([
        document.querySelector('#market-index-columns .content-header'),
        document.querySelector('#market-index-columns .entry-content'),
    ]);

    accordions
        .filter((pair) => Boolean(pair[0]) && Boolean(pair[1]))
        .forEach((pair) => {
            const accordion = new SingleAccordion(pair[0], pair[1], '(max-width: 842px)');
            accordion.toggleOnIconOnly();
            accordion.init();
        });
}
